module.exports = __webpack_public_path__ + "assets/img/completed.03f95906.png";